import React, { useState } from "react";
import Navbar from "../nav_bar/Navbar";
import "./LoginPage.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { resetPassword } from "../../services/userAuthService";

const ResetPasswordPage = () => {
 const { state } = useLocation();
 const navigate = useNavigate();

 const email = state?.email;

 const [otp, setOtp] = useState("");
 const [newPassword, setNewPassword] = useState("");
 const [loading, setLoading] = useState(false);

 // ✅ Custom alert state
 const [alertMessage, setAlertMessage] = useState("");
 const [showAlert, setShowAlert] = useState(false);
 const [alertType, setAlertType] = useState("success"); // success | error

 if (!email) {
 navigate("/login");
 return null;
 }

 const handleReset = async (e) => {
 e.preventDefault();
 setLoading(true);

 try {
 await resetPassword(email, otp, newPassword);

 setAlertMessage("Password reset successful");
 setAlertType("success");
 setShowAlert(true);

 setTimeout(() => {
 setShowAlert(false);
 navigate("/login");
 }, 2000);

 } catch (err) {

 setAlertMessage(err.response?.data?.message || "Invalid OTP");
 setAlertType("error");
 setShowAlert(true);

 setTimeout(() => setShowAlert(false), 2000);
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="login-page">
 <Navbar />

 <main className="login-wrapper">
 <div className="form-container">
 <h2>Reset Password 🔑</h2>
 <p className="subtitle">
 Enter the OTP sent to <strong>{email}</strong>
 </p>

 <form onSubmit={handleReset}>
 <div className="input-group">
 <input
 type="text"
 required
 value={otp}
 onChange={(e) => setOtp(e.target.value)}
 placeholder=" "
 />
 <label>OTP</label>
 </div>

 <div className="input-group">
 <input
 type="password"
 required
 value={newPassword}
 onChange={(e) => setNewPassword(e.target.value)}
 placeholder=" "
 />
 <label>New password</label>
 </div>

 <button className="login-btn" type="submit" disabled={loading}>
 {loading ? "Resetting..." : "Reset Password"}
 </button>
 </form>

 <div className="bottom-links">
 <Link to="/login">Back to login</Link>
 </div>
 </div>
 </main>

 {/* ✅ Custom centered alert */}
 {showAlert && (
 <div className={`custom-alert ${alertType}`}>
 {alertMessage}
 </div>
 )}
 </div>
 );
};

export default ResetPasswordPage;
